module.exports = __webpack_public_path__ + "img/map_quartiere_industriale.bbfdd570.png";